/* eslint-disable max-len */
import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import Select, { createFilter } from 'react-select';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as action from '../action';
import * as c from '../constant';

function UpdateModal({
  profile,
  setFormData,
  formData,
  createInput,
  updateUserManagement,
  getSettings,
  showUserManagement,
  history,
  getRoleList,
  updating,
}) {
  const setModal = useContext(ModalContext);

  const OnSetFormData = () => {
    setFormData({
      barangay_number: profile.attributes.barangay_number || '',
      district_number: profile.attributes.district_number || '',
      zone_number: profile.attributes.zone_number || '',
      name: profile.attributes.name || '',
    });
  };
  const handleOnSubmit = (e) => {
    e.preventDefault();
    updateUserManagement(profile.id, formData, ({ data }) => {
      setModal({ isOpen: false });
      getSettings();
      showUserManagement(profile.id);
      history.push(`/general-settings/brgy-chairmen/${_.get(data, 'id')}`);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      OnSetFormData();
    }
  }, []);

  const createOpts = () => {
    const barangayArr = [];
    const zoneArr = [];
    for (let i = 1; i <= 905; i += 1) {
      barangayArr.push({ label: `Barangay ${i}`, value: i });
    }
    for (let x = 1; x <= 100; x += 1) {
      zoneArr.push({ label: `Zone ${x}`, value: x });
    }
    return { barangay: barangayArr, zone: zoneArr };
  };

  const opts = createOpts();

  const handleChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      OnSetFormData();
    }
  }, [profile]);

  useEffect(() => {
    getRoleList();
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="form-group col-12">
            <label htmlFor="zone" className="full-label mb-0">
              District No.
            </label>
            <Select
              filterOption={createFilter({
                ignoreAccents: false,
              })}
              name="district_number"
              placeholder="Select Module Type"
              onChange={handleChangeSelect('district_number')}
              options={c.DISTRICTS}
              value={
                _.get(formData, 'district_number')
                  ? {
                      value: _.get(formData, 'district_number'),
                      label: _.get(formData, 'district_number'),
                    }
                  : { value: '', label: 'Please Select a district number' }
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="form-group col-12">
            <label htmlFor="zone" className="full-label mb-0">
              Zone No.
            </label>
            <Select
              filterOption={createFilter({
                ignoreAccents: false,
              })}
              name="zone_number"
              placeholder="Select Module Type"
              onChange={handleChangeSelect('zone_number')}
              options={opts.zone}
              value={
                _.get(formData, 'zone_number')
                  ? {
                      value: _.get(formData, 'zone_number'),
                      label: _.get(formData, 'zone_number'),
                    }
                  : { value: '', label: 'Please Select a zone number' }
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 form-group">
            <label>Barangay Number</label>
            <Select
              filterOption={createFilter({
                ignoreAccents: false,
              })}
              name="barangay_number"
              placeholder="Select Module Type"
              onChange={handleChangeSelect('barangay_number')}
              options={opts.barangay}
              value={
                _.get(formData, 'barangay_number')
                  ? {
                      value: _.get(formData, 'barangay_number'),
                      label: _.get(formData, 'barangay_number'),
                    }
                  : { value: '', label: 'Please Select a barangay number' }
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'name', label: 'Barangay Chairman Name' },
              { required: true, placeholder: 'Input Barangay Chairman Name' }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  profile: PropTypes.instanceOf(Object).isRequired,
  updateUserManagement: PropTypes.instanceOf(Function).isRequired,
  getSettings: PropTypes.instanceOf(Function).isRequired,
  showUserManagement: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  // createInputNumber: PropTypes.instanceOf(Function).isRequired,
  getRoleList: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  profile: _.get(api, `${c.GET_SINGLE_SETTING}.item`) || {},
  roleList: _.get(api, `${c.GET_ROLE_LIST}.list`) || [],
  updating: api.loading.indexOf(c.UPDATE_SETTING) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(UpdateModal);
